<template>
  <v-app class="mt-0">
    <Navbar class="nav-on-top" />
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

import Navbar from './views/components/Navbar.vue'


export default {
  name: 'App',
  components: {
    Navbar
  },
  data: () => ({
    //
  }),
};
</script>

<style lang="scss" scoped>
  #app {
    margin-top: 0 ;
    overflow: hidden;
  }
  .nav-on-top {
    z-index: 2000;
  }
</style>


